<template>
  <div class="ac-card-content sve-container">
    <div class="sve-header-container">
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(true, 'edit-visit')"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="sve-header-title">
        Send to Member?
      </div>
    </div>
    <div class="ac-body-container">
      <div class="sve-body-header">
        Share this Virtual Visit
      </div>
      <div class="sve-body-info">
        Virtual Visits will be emailed to the member.
      </div>
      <div class="sve-body-header margin-top-4">
        Add a note?
      </div>
      <div class="sve-input-container">
        <SACInput
          type="textarea"
          field="notes"
          placeholder="Type your message here"
          :value="notes"
          :change="handleInput"
          :max="100"
        />
        <div class="sve-count-container">
          {{ notes.length }}/100
        </div>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="sve-footer-cancel-btn"
        @click="toggleActionModal(true, 'edit-visit')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="sve-footer-delete-btn"
        @click="sendVirtualVisit"
      >
        Send
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>
<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'SendVirtualEmail',
  components: {
    SACInput,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      notes: '',
      processing: false,
    };
  },
  methods: {
    handleInput(field, value) {
      this[field] = value;
    },
    async sendVirtualVisit() {
      this.processing = true;
      try {
        await this.$store.dispatch('sendVirtualVisit', this.notes);
        this.$store.dispatch('showSuccessToast', {
          message: `Virtual Visit email was sent to ${this.customer.email}`,
        });
        this.toggleActionModal(false);
      } catch (err) {
        console.error(err);
      }
      this.processing = false;
    },
  },
};
</script>

<style lang="scss">

.sve-container {
  .sve-header-container {
    display: flex;
    flex-direction: row;
    padding: 20px;
    align-items: center;

    .sve-header-title {
      font-size: 24px;
      font-weight: 600;
      margin-left: 10px;
    }

    .ac-close-button {
      width: 24px;
      height: 24px;
      border-radius: 6px;
      background-color: $NBLUE10;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: $NBLUE20;
      }

      .ac-close {
        width: 10px;
        height: 10px;
      }
    }
  }

  .sve-body-header {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .sve-body-info {
    font-size: 16px;
  }

  .sve-footer-cancel-btn {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $WHITE;
    border: 1px solid $PRIMARY;
    color: $PRIMARY;
    font-weight: 600;
  }

  .sve-footer-delete-btn {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $NBLUE100;
    color: $WHITE;
    font-weight: 600;

    &:hover {
      background-color: $NBLUE100;
    }
  }

  .sve-input-container {
    flex: 1;
    position: relative;

    .sve-count-container {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: right;
      padding: 0 8px 8px 0;
      font-size: 0.75rem;
      color: $N40;
    }
  }

  #sac-input-container {
    height: 100%;
  }

  .sac-textarea {
    flex: 1;
  }
}
</style>
